import { dark } from './theme2/dark';
import { light } from './theme2/light';
import { BodyFontFamily, chakraV3Tokens, HeadingFontFamily } from './tokens';

const toTokenReference = value =>
  typeof value === 'string' && /^[a-z]+\.\d+$/i.test(value)
    ? `{colors.${value}}`
    : value;

const modeToken = (lightValue, darkValue = lightValue) => ({
  value: {
    base: toTokenReference(lightValue),
    _dark: toTokenReference(darkValue),
  },
});

const semanticColors = Object.fromEntries(
  Array.from(
    new Set([...Object.keys(light), ...Object.keys(dark)]),
  ).map(key => [key, modeToken(light[key], dark[key])]),
);

// Plain Chakra v3 config kept independent from the v2 adapter. It can be
// passed to createSystem(defaultConfig, defineConfig(config)) once the
// component APIs and provider have been migrated.
export const chakraV3ThemeConfig = {
  globalCss: {
    body: {
      fontSize: '16px',
      bg: {
        base: '#F8F7F7',
        _dark: '#141414',
      },
      fontFamily: BodyFontFamily,
    },
    heading: {
      fontFamily: HeadingFontFamily,
    },
  },
  theme: {
    tokens: chakraV3Tokens,
    semanticTokens: {
      colors: semanticColors,
    },
  },
};
